export default __webpack_public_path__ + "static/media/clairefontaine10.742186ca.jpg";